import React from 'react';

import {
  ClickableComponent,
  Flexbox,
  FontAwesomeIcon,
  Text,
} from '@schoolinks/ui-components';
import cn from 'classnames';
import { noop } from 'lodash';
import { string, shape, func, bool, oneOfType } from 'prop-types';

import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo';

import s from './PageDetails.css';

const PageDetails = ({
  module,
  title,
  modal,
  openModal,
  classes,
  onboardingFeaturePending,
}) => {
  const hasModal = Boolean(modal);

  return (
    <Flexbox
      className={cn(s.container, classes?.container, {
        [s.noModule]: !module,
      })}
      data-testid="page-details-indicator"
    >
      <div className={s.content}>
        {module && (
          <Text variant="captionReg400" className={s.module}>
            {module}
          </Text>
        )}
        <Text
          className={cn(s.title, classes?.title)}
          component="h1"
          noWrap
          variant="h4"
        >
          {title}
        </Text>
      </div>
      {hasModal && (
        <ClickableComponent
          className={cn(s.modal, {
            [s.onboardingFeaturePending]: onboardingFeaturePending,
          })}
          onClick={openModal}
          aria-label="Open college applications onboarding modal"
        >
          <FontAwesomeIcon icon={faCircleInfo} />
        </ClickableComponent>
      )}
    </Flexbox>
  );
};

PageDetails.propTypes = {
  modal: oneOfType([string, bool]),
  module: string,
  title: string,
  classes: shape({
    container: string,
    title: string,
  }),
  openModal: func,
  onboardingFeaturePending: bool,
};

PageDetails.defaultProps = {
  modal: null,
  module: '',
  classes: {
    container: '',
    title: '',
  },
  onboardingFeaturePending: false,
  title: null,
  openModal: noop,
};

export default PageDetails;
